:host {
  display: block;
}

%button {
  text-align: center;
  line-height: 32px;
  font-weight: 600;
  border-radius: 32px;
  font-size: 14px;
  min-width: 32px;
  height: 32px;
  &:focus-visible {
    outline: 3px solid var(--spw-ds-focus);
  }
}

.spw-pagination {
  display: flex;
  align-items: center;
  padding: 0;

  &__item {
    margin-right: 12px;
    spw-icon {
      font-size: 12px;
    }
    button {
      padding: 0 6px;
      margin: 0;
      border: none;
      cursor: pointer;
      color: var(--spw-color-themes-grey-grey-900);
      background: none;
      @extend %button;
    }

    &:not(.spw-pagination__item--active, .spw-pagination__item--dots, .spw-pagination__item--disabled):hover {
      button {
        background: var(--spw-color-themes-grey-grey-200);
      }
    }

    &:not(.spw-pagination__item--active, .spw-pagination__item--dots, .spw-pagination__item--disabled):active {
      button {
        background: var(--spw-color-themes-grey-grey-300);
      }
    }

    &--arrow {
      button {
        padding: 0 12px;
        display: flex;
        gap: 8px;
        align-items: center;
        text-decoration: underline;
        &:hover {
          text-decoration: none;
        }
      }
    }

    &--dots {
      position: relative;
      top: 3px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: default;
      background: none;
      color: var(--spw-color-themes-grey-grey-400);
      @extend %button;
      spw-icon {
        font-size: 16px;
      }
    }

    &--active {
      button {
        color: white;
        background: var(--spw-ds-primary);
      }
    }
  }

  &__input {
    spw-text-field {
      width: 3ch;
      --spw-input-height: 32px;
      --spw-input-padding: 0 4px;
      --spw-input-text-align: center;
      --spw-input-font-size: 14px;
    }
  }

  &__total-pages {
    font-size: 14px;
    margin: 0 12px 0 6px;
  }
}
